import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ToastModal from "views/components/ToastModal";
import { saveSelfieDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";

const LivePhotoAuthRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const {aadharTranaction} = useSelector((state) => state.loanApplication);
  const {loanApplicationId, loanApplicationNumber, newOrnamentsToggle, mobileNumber} = aadharTranaction;

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    if (!authToken || !loanApplicationId) return;
  
    const key = `selfie-${loanApplicationId}`;
  
    if (sessionStorage.getItem(key)) {
      navigate("/loanservice/inProcess", {
        state: {
          from: "selfie-liveness",
          loanApplicationId,
          loanApplicationNumber,
          newOrnamentsToggle,
          mobileNumber,
        },
      });
      return;
    }
  
    sessionStorage.setItem(key, "true");
    getAadharDetails();
  }, [authToken, loanApplicationId]);
  
  const getAadharDetails = async () => {
    const result = await apiHandler({
      url: endpoint.FACEE_LIVENESS_FETCH_DATA + loanApplicationId,
      authToken,
      method: "POST",
    });
  
    if (!result?.data?.error_code) {
      dispatch(saveSelfieDetails(result.data));
    }
  
    navigate("/loanservice/inProcess", {
      state: {
        from: "selfie-liveness",
        loanApplicationId,
        loanApplicationNumber,
        newOrnamentsToggle,
        mobileNumber,
      },
    });
  };
  return (
    <>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </>
  );
};

export default LivePhotoAuthRedirectHandler;
